export * from './scout-page.component';
export * from './scout-page.module';

export * from './corner/corner.component';
